<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.66699 5.73081V14.9506C1.66699 15.4863 1.95924 15.9922 2.44824 16.1797C4.9656 17.1469 7.48296 16.4862 10.0003 15.8255C12.3094 15.2214 14.6184 14.6143 16.9245 15.2631C17.59 15.4505 18.3337 14.9803 18.3337 14.2691V5.04632C18.3337 4.51063 18.0414 4.00471 17.5524 3.81722C15.035 2.85596 12.5177 3.51664 10.0003 4.17732C7.6913 4.78145 5.38227 5.38559 3.07614 4.73681C2.40773 4.54932 1.66699 5.01954 1.66699 5.73081ZM5.3707 14.7631H3.51884V12.8584C4.54026 12.8584 5.3707 13.7125 5.3707 14.7631ZM3.51884 9.04909V7.14443H5.3707C5.3707 8.19497 4.54026 9.04909 3.51884 9.04909ZM14.63 12.8584C14.63 11.8079 15.4604 10.9538 16.4818 10.9538V12.8584H14.63ZM16.4818 7.14443C15.4604 7.14443 14.63 6.2903 14.63 5.23976H16.4818V7.14443ZM12.7781 10.0014C12.7781 11.8436 11.5339 13.3346 10.0003 13.3346C8.46676 13.3346 7.22255 11.8436 7.22255 10.0014C7.22255 8.15926 8.46676 6.66826 10.0003 6.66826C11.5339 6.66826 12.7781 8.15926 12.7781 10.0014Z"
      fill="#082330"
    />
  </svg>
</template>
